// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3S445","location":"Header_location__IeSkU"};